import request from "../../../../helpers/request";

export const getAlertaPlanoDeAcao = async ({
  id
}) => {
  if (!id) return null;
  const url = `${process.env.REACT_APP_API}/Alerta/${id}`;
  const result = await request({ url, method: "get" });
  return result.data;
};

